import { useParams } from "react-router-dom";
import { useChallengeDetails } from "../../api/challenges/queryHooks";
import { Details } from "./ChallengeDetails";
import { decodeId, formatDate, get_media_url, getDate, getMonth } from "../../api/utils";
import { getAppFunctionForStaticButtons } from "../../components/topbanner";

const ChallengeDetail = ({ data }) => {
  return (
    <div className="h-[70px] max-w-[520px] w-full rounded-2xl bg-[#454755] shadow-lg px-[15px] py-[10px] flex items-center">
      <div className="text-sm text-center flex-shrink-0">
        <p>{getMonth(data.from_date)}</p>
        <p className="text-[#FE0677]">{getDate(data.from_date)}</p>
      </div>
      <div className="h-full border-l border-[#5D5F6E] mx-[10px] flex-shrink-0"></div>
      <div className="text-sm flex-grow truncate">
        <p className="font-semibold truncate">{data.title}</p>
        <p className="text-[10px] text-[#FE0677] truncate">
          Ends on {formatDate(data.to_Date)}
        </p>
      </div>
      <div className="flex-shrink-0 ml-2">
        {/* <p className="font-semibold text-xs">Subscribed</p>
        <p className="text-[9px]">3.4k Subscriber</p> */}
        <button onClick={getAppFunctionForStaticButtons} className="text-sm bg-gradient-to-r from-pinkish to-purpleish max-w-fit px-5 py-1 rounded-2xl">
          {data?.status === "C"
            ? "Completed"
            : data?.status === "U"
            ? "Upcoming"
            : "Subscribe"}
        </button>
      </div>
    </div>
  );
};

const ChallengeCard = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading, isError } = useChallengeDetails(id);

  if (isError) return null;

  if (isLoading)
    return (
      <div className="px-5 mt-[10px] lg:mt-0">
        <div className="h-[210px] w-full sm:h-[320px] md:h-[420px] lg:h-[30vh] rounded-2xl relative skeleton"></div>
      </div>
    );

  return (
    <div className="px-5 mt-[10px] lg:mt-0">
      <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] rounded-2xl relative">
        <img
          className="w-full h-full rounded-2xl object-cover"
          src={get_media_url(data?.data?.cover_image)}
          alt="challenge"
        />
        <div className="absolute bottom-0 w-full px-4 translate-y-1/2 flex justify-center">
          <ChallengeDetail data={data.data} />
        </div>
      </div>
      <div className="hidden mt-12 bg-[#454755] py-5 rounded-xl lg:block">
        <Details />
      </div>
    </div>
  );
};

export default ChallengeCard;
